import jsPDF from "jspdf";
import "jspdf-autotable";
import { isValidArray } from "../../../utils/MyMUtils";
import { toast } from "react-toastify";
import moment from "moment";

const generatePDF = (data, column) => {
  const doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a2",
    putOnlyUsedFonts: true,
  });

  const tableArray = ["State","Vehicle Name","Registration Number","Exp.Date","Driver","Engine Number","Colour","Vin Number"];

  const tableRows = [];

  if (isValidArray(data)) {
    data.forEach((d) => {
      const data = [d.state_name, d.vehical_name, d.rego, moment(d.reg_exp_date).format("DD-MM-YYYY"), d.Driver,d.engine_no,d.colour,d.vin_no];
      tableRows.push(data);
    });

    doc.autoTable(tableArray, tableRows, { startY: 10, startX: 0 });
    const date = Date().split(" ");

    const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];

    doc.save(`Vehicle Details.pdf`);
  } else {
    toast.error("There is no data to export.");
  }
};

export default generatePDF;
